import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
let TaskMangement = class TaskMangement extends VuexModule {
    eventData = {};
    eventMap = {
        //
        hover: {},
        func: {},
    };
    // 更新当前事件数据
    updateEventData(eventData) {
        this.eventData = eventData;
    }
    // 更新当前事件集
    updateEventMap({ key, eventData }) {
        this.eventMap[key] = eventData;
    }
};
__decorate([
    Mutation
], TaskMangement.prototype, "updateEventData", null);
__decorate([
    Mutation
], TaskMangement.prototype, "updateEventMap", null);
TaskMangement = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/task-management/index' })
], TaskMangement);
export const TaskMangementModule = getModule(TaskMangement);
